import { Component, Input, OnInit } from '@angular/core';

import { AlertService } from 'src/app/shared/components/app-alert';
import { ApiService } from 'src/app/shared/services/api.service';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { AwsService } from 'src/app/shared/services/aws.service';
import { WaitingService } from 'src/app/shared/services/waiting.service';

@Component({
  selector: 'app-customer-page-support',
  templateUrl: './customer-page-support.component.html',
  styleUrls: ['./customer-page-support.component.sass']
})
export class CustomerPageSupportComponent implements OnInit {

  @Input() customerId: string;

  public commands: Array<any> = [];
  public choosedCommands: Array<any> = [];
  public selectedAvailableCommand = {};
  public selectedCommand;
  public additionalRecipients;

  public file: File;

  constructor(
    private api: ApiService,
    private aws: AwsService,
    private waiting: WaitingService,
    private alert: AlertService,
    private authentication: AuthenticationService) { }

  ngOnInit(): void {
    this.api.get('commands',
      (result: any) => {
        this.commands = result;
        this.selectedAvailableCommand = this.commands.length > 0 ? this.commands[0] : undefined;
    });
  }

  onCommandClick(i: number) {
    this.selectedCommand = this.choosedCommands[i];
    this.choosedCommands.forEach((command, index) => command.active = (i === index) ? true : undefined);
  }

  onAddCommand() {
    if (this.selectedAvailableCommand) {
      const clone = this.CloneCommand(this.selectedAvailableCommand);
      const index = this.choosedCommands.push(clone);
      this.onCommandClick(index - 1);
    }
  }

  onCommandDown(i) {
    if (i != this.choosedCommands.length - 1) {
      var temp = this.choosedCommands[i];
      this.choosedCommands[i] = this.choosedCommands[i + 1];
      this.choosedCommands[i + 1] = temp;
    }
  }

  onCommandUp(i) {
    if (i != 0) {
      var temp = this.choosedCommands[i];
      this.choosedCommands[i] = this.choosedCommands[i - 1];
      this.choosedCommands[i - 1] = temp;
    }
  }

  onCommandRemove(i) {
    if (this.choosedCommands[i] === this.selectedCommand) {
      this.selectedCommand = undefined;
    }
    this.choosedCommands.splice(i, 1);
  }

  onFileChange(event, param) {
    if (event.target.files.length > 0) {
      param.file = event.target.files[0];
    }
  }

  onSend() {
    if (this.ValidateParams())
      this.SendCommands();
  }

  private CloneCommand(command) {
    const clone = JSON.parse(JSON.stringify(command));
    clone.Params.forEach(param => param.Value = param.DefaultValue);
    return clone;
  }

  private SendCommands() {
    const promises = [];
    this.choosedCommands.forEach(command => {
      command.Params.forEach(param => {
        if (param.file) {
          promises.push(this.aws.uploadFileToS3('au-commands', `files/${param.file.name}`, param.file));
        }
      });
    });
    this.waiting.show();
    Promise.all(promises)
      .then(results => {
        this.choosedCommands.forEach(command => {
          command.Params.forEach(param => {
            if (param.file) {
              param.Value = results.shift().Location;
              param.file = undefined;
            }
          });
        });
        const recipients = this.authentication.getLoggedUser().Email.concat(this.additionalRecipients ? `,${this.additionalRecipients}` : '');
        this.api.put(`customers/${this.customerId}/SetCommand`,
          this.choosedCommands,
          () => this.alert.info('Commands were sent successfuly.'),
          { recipients: recipients });
      })
      .catch((err) => this.alert.error(err))
      .finally(() => this.waiting.hide());
  }

  private ValidateParams() {
    const find = this.choosedCommands.find(command => command.Params.some(param => param.Required && !(param.Value || param.file)));

    if (find) {
      this.alert.error('One of required command arguments is empty.');
      this.selectedCommand = find;
      return false;
    }

    return true;
  }

}
